import * as Yup from 'yup';
// helpers/constants
import * as G from '../../../helpers';
import { FIELD_NAME } from '../../../constants';
//////////////////////////////////////////////////

export const saveTemplateFields = [
  {
    type: 'text',
    isRequired: true,
    fieldName: FIELD_NAME,
    label: ['titles:template-name'],
    inputWrapperStyles: { mb: 25, width: 300 },
  },
];

export const saveTemplateValidationSchema = Yup.object().shape({
  [FIELD_NAME]: Yup.string()
    .nullable(true)
    .required(G.getRequiredLocaleTxt()),
});
